/**
 * Storage helpers for the amicale validation space.
 * Uses dedicated localStorage keys so the moteur auto-login session
 * (accessToken / refreshToken / user) is never touched.
 */

export const STORAGE_KEYS = {
  accessToken: 'amicaleValidationAccessToken',
  refreshToken: 'amicaleValidationRefreshToken',
  user: 'amicaleValidationUser',
  client: 'amicaleValidationClient',
};

const safeGet = (key) => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key, value) => {
  if (typeof window === 'undefined') return;
  try {
    if (value == null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch {
    /* ignore quota / privacy mode */
  }
};

export const getAmicaleValidationAccessToken = () =>
  safeGet(STORAGE_KEYS.accessToken);

export const getAmicaleValidationRefreshToken = () =>
  safeGet(STORAGE_KEYS.refreshToken);

export const getAmicaleValidationUser = () => {
  const raw = safeGet(STORAGE_KEYS.user);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const getAmicaleValidationClient = () => {
  const raw = safeGet(STORAGE_KEYS.client);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const persistAmicaleValidationSession = ({
  accessToken,
  refreshToken,
  user,
  client,
}) => {
  if (accessToken) safeSet(STORAGE_KEYS.accessToken, accessToken);
  if (refreshToken) safeSet(STORAGE_KEYS.refreshToken, refreshToken);
  if (user) safeSet(STORAGE_KEYS.user, JSON.stringify(user));
  if (client) safeSet(STORAGE_KEYS.client, JSON.stringify(client));
};

export const clearAmicaleValidationSession = () => {
  Object.values(STORAGE_KEYS).forEach((key) => safeSet(key, null));
};
